import { actionCreatorFactory } from "typescript-fsa";

const actionCreator = actionCreatorFactory("EXPERIMENTS");

export const bootstrapped = actionCreator<any>("BOOTSTRAPPED");



// WEBPACK FOOTER //
// ./frontend/src/common/actions/Experiments.ts